module.exports = __webpack_public_path__ + "img/add-product.b9d94ebc.png";